import api from '../api';
import { ASSIGN_BABY_COUNT, SET_INVITE_TOKEN } from '../actions/onboarding';
import { LOGOUT_SUCCESS } from '../actions/logout';

const initialState = {
  lastProfileCreated: {},
  babyCount: 1,
  inviteToken: ''
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ASSIGN_BABY_COUNT:
      return { ...state, babyCount: parseInt(action.payload, 10) };
    case SET_INVITE_TOKEN:
      return { ...state, inviteToken: action.token };
    case api.events.profilesPost.actionSuccess:
      return {
        ...state,
        lastProfileCreated: action.data
      };
    case api.events.profilesPatch.actionSuccess:
      return {
        ...state,
        lastProfileCreated: action.data
      };
    case LOGOUT_SUCCESS:
      return initialState;
    default:
      return state;
  }
};
